export default __webpack_public_path__ + "static/media/location-unavailable@2x.cb96307a.png";